import { useState, useEffect } from 'react';
import { Modal, Button } from '@components/ui';

export default function GenelStokModal({ isOpen, onClose, onSubmit, data, isLoading = false }) {
    const [stok, setStok] = useState(0);
    const [not, setNot] = useState('');

    useEffect(() => {
        if (data) setStok(data.stokMiktar || 0);
    }, [data]);

    const handleSubmit = () => { onSubmit({ stokMiktar: stok, kullanilanMiktar: (data?.miktar || 0) - stok, not }); };

    if (!data) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Stok Güncelle" size="sm"
            footer={<><Button variant="ghost" onClick={onClose} disabled={isLoading}>İptal</Button><Button variant="success" onClick={handleSubmit} isLoading={isLoading}>Güncelle</Button></>}>
            <div className="space-y-4">
                <div className="p-3 bg-bg-tertiary rounded-lg">
                    <p className="font-medium text-text-primary">{data.urunAdi}</p>
                    <p className="text-sm text-text-muted">{data.aciklama}</p>
                    <p className="text-sm text-text-secondary mt-1">Toplam: {data.miktar?.toLocaleString('tr-TR')} {data.birim}</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Mevcut Stok ({data.birim})</label>
                    <input type="number" value={stok} onChange={(e) => setStok(Math.max(0, parseInt(e.target.value) || 0))}
                        className="w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-success/50" />
                </div>
                <div className="space-y-1">
                    <div className="flex justify-between text-xs text-text-muted"><span>Kullanım</span><span>%{data.miktar > 0 ? Math.round(((data.miktar - stok) / data.miktar) * 100) : 0}</span></div>
                    <div className="h-2 bg-bg-tertiary rounded-full overflow-hidden">
                        <div className="h-full bg-success rounded-full transition-all" style={{ width: `${data.miktar > 0 ? ((data.miktar - stok) / data.miktar) * 100 : 0}%` }} />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Not</label>
                    <input type="text" value={not} onChange={(e) => setNot(e.target.value)} placeholder="Güncelleme notu..."
                        className="w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50" />
                </div>
            </div>
        </Modal>
    );
}
